var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { GameComponent } from '../game/game.component';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SocketService } from '../shared/services/socket.service';
import { MessageType } from '../shared/model/message-type';
import { HttpClient } from '@angular/common/http';
import { getServerUrl } from '../shared/utils/utils';
import { GameStatus } from '../shared/model/game-status';
import { DrawingPadComponent } from '../drawing-pad/drawing-pad.component';
var TelestrationsComponent = /** @class */ (function (_super) {
    __extends(TelestrationsComponent, _super);
    function TelestrationsComponent(socketService, cookieService, router, resolver, httpClient) {
        var _this = _super.call(this, socketService, cookieService, router, resolver) || this;
        _this.httpClient = httpClient;
        _this.isDrawMode = false;
        _this.isGuessMode = false;
        _this.pictureHash = '';
        _this.wordToDraw = '';
        _this.guess = '';
        _this.waitMode = false;
        return _this;
    }
    TelestrationsComponent.prototype.messageHandler = function (m) {
        if (m.action === MessageType.Prompt ||
            (m.action === MessageType.Host && m.content.status === GameStatus.InProgress)) {
            this.requestPrompt();
        }
    };
    TelestrationsComponent.prototype.sendResponse = function (message) {
        this.waitMode = true;
        this.isDrawMode = false;
        this.isGuessMode = false;
        var submission = {
            answer: message
        };
        this.socketService.send({
            from: this.user,
            content: submission,
            action: MessageType.Response,
            gameId: this.gameId
        });
        this.guess = '';
    };
    TelestrationsComponent.prototype.timerChangeHandler = function (timerStatus) {
        if (timerStatus.status.ended) {
            if (this.isDrawMode) {
                this.sendResponse(this.drawingPad.getCurrentDrawing());
            }
            else {
                this.sendResponse(this.guess);
            }
        }
    };
    TelestrationsComponent.prototype.requestPrompt = function () {
        var _this = this;
        var url = getServerUrl(this.gameId) + "/request-prompt";
        var body = {
            gameId: this.gameId,
            username: this.user.name
        };
        this.httpClient.request('post', url, { body: body }).subscribe(function (resp) {
            if (resp.success) {
                console.log(resp);
                if (resp.hasSubmitted) {
                    _this.isDrawMode = false;
                    _this.isGuessMode = false;
                    _this.wordToDraw = '';
                    _this.pictureHash = '';
                    _this.waitMode = true;
                }
                else if (resp.promptType === 'draw') {
                    _this.isDrawMode = true;
                    _this.isGuessMode = false;
                    _this.wordToDraw = resp.prompt;
                    _this.waitMode = false;
                    _this.showWaiting = false;
                    _this.expiration = resp.expiration;
                    _this.timeLimit = resp.timeLimit;
                }
                else {
                    _this.isDrawMode = false;
                    _this.isGuessMode = true;
                    _this.pictureHash = resp.prompt;
                    _this.waitMode = false;
                    _this.showWaiting = false;
                    _this.expiration = resp.expiration;
                    _this.timeLimit = resp.timeLimit;
                }
            }
            else {
                console.log('aww shit...');
            }
        }, function (error) {
            console.log(error);
        });
    };
    return TelestrationsComponent;
}(GameComponent));
export { TelestrationsComponent };
